import React, { useRef } from "react";

import { Box, Drawer, ModalProps, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";

import { useActualInventoryContext } from "Hooks/useActualInventoryContext";
import { useOutsideAlerter } from "Hooks/useOutsideAlerter";
import ImageLoading from "Components/Generic/ImageLoading";
import useStyles from "./styles";

type Props = {
  open?: boolean;
  onClose?: ModalProps["onClose"];
};

const DrawerPhotos = (props: Props) => {
  const { open, onClose } = props;

  const { itemJob } = useActualInventoryContext();

  const classes = useStyles();

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => onClose && onClose({}, "backdropClick"));

  const { t: translate } = useTranslation();

  const renderPictures = () => {
    if (itemJob && itemJob?.pictures && itemJob?.pictures?.length > 0) {
      return itemJob?.pictures?.map((picture) => {
        if (picture && picture?.mediaLink)
          return <ImageLoading src={picture?.mediaLink} className={classes.image} />;

        return <></>;
      });
    }

    return null;
  };

  return (
    <Drawer
      PaperProps={{ className: classes.paperProps }}
      anchor="right"
      open={open}
      onClose={onClose}
      hideBackdrop
      ModalProps={{ className: classes.modalProps }}
    >
      <Box ref={wrapperRef} minWidth="254px" padding="24px 16px">
        <Stack direction="row" justifyContent="space-between">
          <Typography
            color="#465869"
            fontFamily="Manrope"
            fontWeight={700}
            fontSize="16px"
            lineHeight="24px"
          >
            {translate("photos")}
          </Typography>
          <HiOutlineChevronDoubleRight
            onClick={() => onClose && onClose({}, "escapeKeyDown")}
            className={classes.icon}
          />
        </Stack>
        <Stack className={classes.containerPictures} direction="column" spacing={2}>
          {renderPictures()}
        </Stack>
      </Box>
    </Drawer>
  );
};

export default DrawerPhotos;
